import { render } from "./HomeProductItem.vue?vue&type=template&id=5c2e075d"
import script from "./HomeProductItem.vue?vue&type=script&lang=js"
export * from "./HomeProductItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__